export const market = {
    // Клик на карточку товара Purina (cat) + лакомства
    marketPurinaCatProduct: {
        rbmail: {
            type: 'click',
            id: '90879852',
        },
    },
    // Клик на карточку товара Purina (dog) + лакомства
    marketPurinaDogProduct: {
        rbmail: {
            type: 'click',
            id: '90879851',
        },
    },
    // Клик на карточку корма все бренды (cat) + лакомства
    marketCatProduct: {
        rbmail: {
            type: 'click',
            id: '90879963',
        },
    },
    // Клик на карточку корма все бренды (dog) + лакомства
    marketDogProduct: {
        rbmail: {
            type: 'click',
            id: '90879972',
        },
    },
    // Клик на карточку товара категории «Аксессуары и игрушки»
    marketToysCategory: {
        rbmail: {
            type: 'click',
            id: '90879953',
        },
    },
    // Клик на карточку товара категории «Гигиена и уход»
    marketHygieneCategory: {
        rbmail: {
            type: 'click',
            id: '90879977',
        },
    },
    // Клик на шапку Магазин
    marketHeader: {
        rbmail: {
            type: 'click',
            id: '90879953',
        },
    },
    // Клик на кнопку «Корм для кошек»
    marketCatFood: {
        rbmail: {
            type: 'click',
            id: '90879818',
        },
    },
    // Клик на кнопку «Корм для собак»
    marketDogFood: {
        rbmail: {
            type: 'click',
            id: '90879820',
        },
    },
    // Клик на кнопку «Сухой корм» (cat)
    marketDryCatFood: {
        rbmail: {
            type: 'click',
            id: '90879823',
        },
    },
    // Клик на кнопку «Влажный корм» (cat)
    marketWetCatFood: {
        rbmail: {
            type: 'click',
            id: '90879825',
        },
    },
    // Клик на кнопку «Сухой корм» (dog)
    marketDryDogFood: {
        rbmail: {
            type: 'click',
            id: '90879828',
        },
    },
    // Клик на кнопку «Влажный корм» (dog)
    marketWetDogFood: {
        rbmail: {
            type: 'click',
            id: '90879831',
        },
    },
    // Клик на кнопку «Лакомства»
    marketTreats: {
        rbmail: {
            type: 'click',
            id: '90879837',
        },
    },
    // Клик на кнопку «Лакомства» (cat)
    marketCatTreats: {
        rbmail: {
            type: 'click',
            id: '90879839',
        },
    },
    // Клик на кнопку «Лакомства (dog)
    marketDogTreats: {
        rbmail: {
            type: 'click',
            id: '90879842',
        },
    },
    // Клик на кнопку «Аксессуары и игрушки» + клик на кнопку «Посмотреть все» на главной стр.
    marketToys: {
        rbmail: {
            type: 'click',
            id: '90879845',
        },
    },
    // Клик на кнопку «Гигиена и уход» + клик на кнопку «Посмотреть все» на главной стр.
    marketHygiene: {
        rbmail: {
            type: 'click',
            id: '90879848',
        },
    },
    // Клик на кнопку «Подробнее» в карточке товара
    marketAboutClick: {
        rbmail: {
            type: 'click',
            id: '103095388',
        },
    },
    // Клик на кнопку «Купить» в карточке товара
    marketAboutClickExp: {
        rbmail: {
            type: 'click',
            id: '107788908',
        },
    },
    // Показ кнопки «Подробнее» в карточке товара
    marketAboutShow: {
        rbmail: {
            type: 'display',
            id: '103095390',
        },
    },
    // Клик на кнопку «Купить» в карточке товара
    marketAboutShowExp: {
        rbmail: {
            type: 'display',
            id: '107788908',
        },
    },
    // Клик по кнопке «Магазины» в карточке товара
    marketStoreBtnClick: {
        rbmail: {
            type: 'click',
            id: '103151173',
        },
    },
    // Показ кнопки «Магазины» в карточке товара
    marketStoreBtnShow: {
        rbmail: {
            type: 'display',
            id: '103151173',
        },
    },
};
